<router-outlet />

@if (isDevelopment()) {
  <app-theme-toolbar />
}
